var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloudLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 135,
  height: 134,
  viewBox: "0 0 135 134",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 134,
  height: 134,
  rx: 31.3438,
  fill: "#0077FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.9052 40.9648C53.8601 40.9648 45.7169 49.2136 45.7169 59.3889C45.7169 60.2652 45.7769 61.1245 45.8924 61.9633L46.6569 67.5155L41.124 67.6329C34.5921 67.7715 29.3373 73.1809 29.3373 79.8322C29.3373 86.5713 34.7304 92.0343 41.3832 92.0343C56.8903 92.0343 73.4085 92.0351 90.5219 92.0351C99.4362 92.0351 106.663 84.7149 106.663 75.685C106.663 66.6551 99.4362 59.3349 90.5219 59.3349C89.4763 59.3349 88.4584 59.4349 87.4755 59.6247L82.6962 60.5477L81.7331 55.7167C80.0552 47.3003 72.7051 40.9648 63.9052 40.9648ZM90.9247 101.997V102H40.7583V101.99C28.9615 101.655 19.5 91.863 19.5 79.8322C19.5 69.5087 26.466 60.8342 35.8974 58.3678C36.4281 43.162 48.7645 31 63.9052 31C75.906 31 86.1374 38.6369 90.1351 49.3729C90.2638 49.371 90.3928 49.37 90.5219 49.37C104.869 49.37 116.5 61.1516 116.5 75.685C116.5 90.082 105.086 101.779 90.9247 101.997Z",
  fill: "white"
})));
export { SvgCloudLogo as ReactComponent };